import { useCallback, useEffect, useState } from 'react';
import { PanelLeft } from 'lucide-react';
import Navbar from './Navbar';
import Footer from './Footer';
import AppSidebar from './AppSidebar';
import { AppLayoutChromeProvider } from './AppLayoutContext';

function LoggedInAppLayout({ children, pageClassName = '' }) {
  const isDrawingToolPage = pageClassName.includes('new-2d-project-page');
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const [navMobileMenuOpen, setNavMobileMenuOpen] = useState(false);
  const [desktopSidebarCollapsed, setDesktopSidebarCollapsed] = useState(isDrawingToolPage);
  const hideFooter = isDrawingToolPage
    || pageClassName.includes('cubicasa-mask-debug-page');

  const closeSidebar = useCallback(() => {
    setMobileSidebarOpen(false);
  }, []);

  const toggleSidebar = useCallback(() => {
    setMobileSidebarOpen((open) => !open);
  }, []);

  useEffect(() => {
    if (!mobileSidebarOpen) return undefined;

    const onKeyDown = (event) => {
      if (event.key === 'Escape') closeSidebar();
    };

    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', onKeyDown);

    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', onKeyDown);
    };
  }, [mobileSidebarOpen, closeSidebar]);

  useEffect(() => {
    if (navMobileMenuOpen) {
      setMobileSidebarOpen(false);
    }
  }, [navMobileMenuOpen]);

  useEffect(() => {
    setDesktopSidebarCollapsed(isDrawingToolPage);
  }, [isDrawingToolPage]);

  return (
    <>
      <Navbar onMobileMenuOpenChange={setNavMobileMenuOpen} />
      <main
        className={`dashboard-page app-layout-page${desktopSidebarCollapsed ? ' app-layout-page--sidebar-collapsed' : ''}${pageClassName ? ` ${pageClassName}` : ''}`}
      >
        <div className="container app-layout">
          <AppSidebar
            mobileOpen={mobileSidebarOpen}
            onClose={closeSidebar}
            pageClassName={pageClassName}
            collapsed={desktopSidebarCollapsed}
            onCollapsedChange={setDesktopSidebarCollapsed}
          />
          <div className="app-layout-main">
            {!navMobileMenuOpen ? (
              <div className="app-layout-main-toolbar">
                <button
                  type="button"
                  className="app-layout-mobile-toggle"
                  onClick={toggleSidebar}
                  aria-expanded={mobileSidebarOpen}
                  aria-controls="app-sidebar"
                  aria-label={mobileSidebarOpen ? 'Close AI Tools menu' : 'Open AI Tools menu'}
                >
                  <span className="app-layout-mobile-toggle-icon" aria-hidden="true">
                    <PanelLeft size={20} strokeWidth={2} />
                  </span>
                  <span className="app-layout-mobile-toggle-label">AI Tools</span>
                </button>
              </div>
            ) : null}
            <AppLayoutChromeProvider>
              {children}
            </AppLayoutChromeProvider>
            {!hideFooter ? (
              <div className="app-layout-footer">
                <Footer />
              </div>
            ) : null}
          </div>
        </div>
      </main>
    </>
  );
}

export default LoggedInAppLayout;
